import TypedNativeModules from "../internal/TypedNativeModules";

export async function logTapButtonWithExtraParams(
  screenName: string,
  elementName: string,
  tags: string[],
  extraParams: Record<string, string | number | boolean>,
): Promise<void> {
  const tareBridge = TypedNativeModules.RNTareBridge;
  if (!tareBridge?.logTapButtonWithExtraParams) {
    return;
  }

  await tareBridge.logTapButtonWithExtraParams(screenName, elementName, tags, extraParams);
}
